import React from 'react'
import { COUNTRY_CODE_LIST } from '../../internationalization/const'

export const renderCountryName = (countryCode) => {
    const country = COUNTRY_CODE_LIST.find(item => item.id === countryCode)
    return country ? country.value : ''
}

export const renderTreatingPhysicianList = (treatingPhysicianList) => {
    const treatingPhysicianArray = treatingPhysicianList.split(",");

    return <div>
        {treatingPhysicianArray.map(treatingPhysician => {
            return (<div key={treatingPhysician}>{treatingPhysician}</div>
            )
        })}
    </div>
}



// WEBPACK FOOTER //
// ./src/modules/store/util/names.js